import React from 'react';
import UserCard from './userCard';
import styles from './explore.module.css'

const Rrequest=()=>{
    return(
        <div className={styles.CardList} >
           <UserCard
           buttons={
               <div>
           <button className="followbtn">Accept</button>
           <span> </span>
            <button className="unfollowbtn">Cancel</button>
            </div>
        }
           
           />
           <UserCard
           buttons={
               <div>
           <button className="followbtn">Accept</button>
           <span> </span>
            <button className="unfollowbtn">Cancel</button>
            </div>
        }
           
           />
           <UserCard
           buttons={
               <div>
           <button className="followbtn">Accept</button>
           <span> </span>
            <button className="unfollowbtn">Cancel</button>
            </div>
        }
           
           />
           <UserCard
           buttons={
               <div>
           <button className="followbtn">Accept</button>
           <span> </span>
            <button className="unfollowbtn">Cancel</button>
            </div>
        }
           
           />
           <UserCard
           buttons={
               <div>
           <button className="followbtn">Accept</button>
           <span> </span>
            <button className="unfollowbtn">Cancel</button>
            </div>
        }
           
           />
           <UserCard
           buttons={
               <div>
           <button className="followbtn">Accept</button>
           <span> </span>
            <button className="unfollowbtn">Cancel</button>
            </div>
        }
           
           />

        </div>
    )
}


export default Rrequest